// src/utils/rewriteImageUrl.js
const IMG_HOST = "https://instruireauto.site";
const EXAMEN_TOKENS = new Set([
   "exameninstruireauto",
   "exameninstruiereauto",
]);

const norm = (s) => String(s || "").toLowerCase().replace(/[-_]+/g, "");

export function rewriteImageUrl(raw) {
   if (!raw) return null;
   try {
      const u = new URL(String(raw).trim(), IMG_HOST);
      const segs = u.pathname.split("/").filter(Boolean);

      let idx = segs.findIndex((p) => EXAMEN_TOKENS.has(norm(p)));

      if (idx !== -1) {
         segs[idx] = "images";
         if (norm(segs[idx + 1]) === "images") {
            segs.splice(idx + 1, 1);
         }
      } else if (segs.length && norm(segs[0]) !== "images") {
         segs.unshift("images");
      }

      u.pathname = "/" + segs.join("/");
      u.pathname = u.pathname.replace(/\/{2,}/g, "/");
      return u.origin + u.pathname;
   } catch {
      const tail = String(raw)
         .trim()
         .replace(/^https?:\/\/[^/]+/i, "")
         .replace(/^\/+/, "");
      const m = tail.match(/EXAMEN[-_]?INSTRUI(?:RE|ERE)[-_]?AUTO\/(.+)/i);
      const tailClean = m ? m[1] : tail;
      const normalizedTail = String(tailClean).replace(/^images\/+/i, "");
      return `${IMG_HOST.replace(/\/+$/, "")}/images/${normalizedTail}`.replace(
         /\/{2,}/g,
         "/"
      );
   }
}
